/**
 * How a diner wants this order served: eaten in on the table's shared bill, or
 * collected at the counter. Distinct from the site's `entryMode` (how a table
 * is joined) and its `OrderingMode` (whether the menu takes orders at all).
 */
const ORDER_MODE = {
  DINE_IN: 'dine_in',
  TAKEAWAY: 'takeaway'
} as const

type OrderMode = (typeof ORDER_MODE)[keyof typeof ORDER_MODE]

export { ORDER_MODE }
export type { OrderMode }
